import { render } from "./SystemSettingsGeneral.vue?vue&type=template&id=9ccde7b8&ts=true"
import script from "./SystemSettingsGeneral.vue?vue&type=script&lang=ts"
export * from "./SystemSettingsGeneral.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__